import React, { Fragment, useState } from "react";
import * as Yup from "yup";
import { Formik, Form } from "formik";

// Components
import GeneralInformation from "./Steps/GeneralInformation";
import Calender from "./Steps/Calender";
import MultiStep from "./Wizard"
import AppFooter from "Layout/AppFooter";
import axiosInstance from "Api";
import { useLocation, useNavigate } from "react-router";
import AuthService from "Api/Auth";
import { rolesList } from "Components/Router/Permission";
import { coordinatorPath } from "Layout/AppNav/helpers";
import { melderPath } from "Layout/AppNav/helpers";
import { WizardContextProvider } from "../WizardContext";
import { AbsentsProvider } from "Pages/Melder/Indienen/AbsentsContext";

export const initialValues = {
    organisationId: '',
    schoolId: '',
    absentId: '',
    groupsId: [],
    codeId: '',
    type: '',
    planning: '',
    label: '',
    iHowToInformId: '',
    informEmailExtra1: '',
    informEmailExtra2: [],

    gym: [],
    substitutionNote: '',
    schedulerNote: '',
    dateRange: [],
}

const initialFormValues = {
    organisation: '',
    school: '',
    absent: '',
    groups: [],
    code: '',
    type: '',
    planning: '',
    label: '',
    isOpen: false,

    iHowToInformId: '',
    informEmailExtra1: [],
    informEmailExtra2: [],

    gym: [],
    substitutionNote: '',
    schedulerNote: '',
    schedulerNoteUI: '',
    dateRange: [],
}

const validationSchema = Yup.object().shape({
    organisationId: Yup.string().required('Verplicht veld'),
    schoolId: Yup.string().required('Verplicht veld'),
    groupsId: Yup.array().min(1, 'Selecteer minimaal 1 groep').required('Verplicht veld'),
    codeId: Yup.string().required('Verplicht veld'),
    planning: Yup.string().required('Verplicht veld'),
    dateRange: Yup.array().min(1, 'Selecteer minimaal 1 of meer dagdelen').required('Verplicht veld'),
    informEmailExtra2: Yup.array().of(Yup.string().email('Ongeldig e-mail')),
});

const steps = (
    formikProps,
    formDataState,
    setFormDataState,
    isDisabled,
    setIsDisabled,
    link,
    setLink
) => [
        {
            name: "Basis informatie",
            component: <GeneralInformation
                formikProps={formikProps}
                formDataState={formDataState}
                setFormDataState={setFormDataState}
                isDisabled={isDisabled}
                setIsDisabled={setIsDisabled}
                link={link}
                setLink={setLink} />
        },
        {
            name: "Selecteer dagen",
            component: <Calender
                formikProps={formikProps}
                formDataState={formDataState}
                setFormDataState={setFormDataState}

            />
        },
    ];

const Substitution = ({ match }) => {
    const [formDataState, setFormDataState] = useState(initialFormValues); // 'global' state for whole form
    const [isDisabled, setIsDisabled] = useState(false);
    const [link, setLink] = useState(null);
    const [disabledButton, setDisabledButton] = useState(false);

    const location = useLocation();
    const navigate = useNavigate();
    const isCoordinator = AuthService.getUserRoles().includes(rolesList.coordinator.name);

    const onSubmit = (data) => {
        setDisabledButton(true);
        const rawSchedulerNote = formDataState.schedulerNote || '';
        const rawPlannerNote = formDataState.substitutionNote || '';

        const cleanNote = rawSchedulerNote
            .replace(/\[([^\]]+)\]/g, '$1')
            .replace(/@@(\d+)\|([^@]+)@@/g, '@$2')
            .replace(/\n+/g, ' ')
            .replace(/(@[^\s]+)\s+@/g, '$1 @')
            .replace(/^\s+|\s+$/g, '')
            .replace(/\s+$/, '')
            .trim();
        const cleanPlannerNote = rawPlannerNote
            .replace(/\[([^\]]+)\]/g, '$1')
            .replace(/@@(\d+)\|([^@]+)@@/g, '@$2')
            .replace(/\n+/g, ' ')
            .replace(/(@[^\s]+)\s+@/g, '$1 @')
            .replace(/^\s+|\s+$/g, '')
            .replace(/\s+$/, '')
            .trim();

        const isMelderIndienenPath = melderPath.verzoeken.includes(location.pathname);
        const user = isMelderIndienenPath ? 'melder' : 'coordinator';
        const submitData = {
            ...data,
            schedulerNote: cleanNote,
            substitutionNote: cleanPlannerNote,
            user,
        };
        const filteredSubmitData = Object.fromEntries(
            Object.entries(submitData).filter(([key, value]) => {
                if (key !== "substitutionNote") {
                    return true;
                } else if (typeof value === 'string' && value.trim().length > 0) {
                    return true;
                }
                return false;
            })
        );

        const isCoordinatorIndienenPath = coordinatorPath.verzoeken.includes(location.pathname);

        axiosInstance.post('requisition', filteredSubmitData)
            .then((response) => {
                if (response.data.status === "success") {
                    isCoordinator && isCoordinatorIndienenPath
                        ? navigate("/verzoeken/overzicht")
                        : navigate("/verzoeken");

                    setDisabledButton(false);
                } else {
                    console.error("Submit failed:", response.data);
                }
            })
            .catch((err) => console.error("Error submitting form:", err));
        setFormDataState(initialFormValues);
    };


    return (
        <Fragment>

            <Formik
                initialValues={initialValues}
                validationSchema={validationSchema}
                onSubmit={(data) => onSubmit(data)}
            >
                {(formikProps) => (
                    <Form>
                        <WizardContextProvider>
                            <AbsentsProvider>
                                <MultiStep
                                    formikProps={formikProps}
                                    nextDisabled={isDisabled}
                                    setDisabled={setIsDisabled}
                                    disabledButton={disabledButton}
                                    handleSubmit={formikProps.handleSubmit}
                                    showNavigation={true}
                                    leaveLink={link}
                                    steps={steps(
                                        formikProps,
                                        formDataState,
                                        setFormDataState,
                                        isDisabled,
                                        setIsDisabled,
                                        link,
                                        setLink,

                                    )} />
                            </AbsentsProvider>
                        </WizardContextProvider>
                    </Form>
                )}
            </Formik>
            {/* <AppFooter /> */}
        </Fragment>
    )
};

export default Substitution;